/* No tracking. Native links/details remain usable if JavaScript is unavailable. */
function prepareGlamosiaMenus(root=document){root.querySelectorAll('.g-nav').forEach(n=>{n.dataset.enhanced='true';});}
prepareGlamosiaMenus();
document.addEventListener('shopify:section:load',e=>prepareGlamosiaMenus(e.target));
function closeGlamosiaMenu(n,restore=false){n.querySelectorAll('details[open]').forEach(d=>d.open=false);n.dataset.menuOpen='false';const b=n.querySelector('.g-nav__mobile-toggle');if(b){b.setAttribute('aria-expanded','false');if(restore)b.focus();}}
document.addEventListener('click',e=>{
 const scroll=e.target.closest('[data-g-scroll]');if(scroll){const rail=document.getElementById(scroll.dataset.gTarget);if(rail)rail.scrollBy({left:rail.clientWidth*Number(scroll.dataset.gScroll),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
 const menu=e.target.closest('.g-nav__mobile-toggle');if(menu){const n=menu.closest('.g-nav');const open=n.dataset.menuOpen!=='true';n.dataset.menuOpen=String(open);menu.setAttribute('aria-expanded',String(open));if(!open)closeGlamosiaMenu(n);}
 const back=e.target.closest('.g-nav__back');if(back){const d=back.closest('details');d.open=false;d.querySelector('summary').focus();}
 if(!e.target.closest('.g-nav'))document.querySelectorAll('.g-nav').forEach(n=>closeGlamosiaMenu(n));
});
document.addEventListener('toggle',e=>{if(e.target.matches('.g-nav details[open]'))e.target.closest('.g-nav').querySelectorAll('details[open]').forEach(d=>{if(d!==e.target)d.open=false;});},true);
document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.g-nav').forEach(n=>{const d=n.querySelector('details[open]');if(d){d.open=false;d.querySelector('summary').focus();}else if(n.dataset.menuOpen==='true')closeGlamosiaMenu(n,true);});});

/* Glamosia navigation v6: panel focus retention, touch scrolling, direct toggle dismissal. */
(() => {
  if (window.glamosiaNavigationV6 || window.glamosiaNavigationV5) return;
  window.glamosiaNavigationV6 = true;
  // Retain the legacy guard so mixed cached assets cannot bind twice.
  window.glamosiaNavigationV5 = true;
  const desktop = matchMedia('(min-width:901px) and (hover:hover)');
  const states = new WeakMap();
  const clearOpen = s => { clearTimeout(s.openTimer); s.openTimer = null; };
  const clearClose = s => { clearTimeout(s.closeTimer); s.closeTimer = null; };
  const panelHasFocus = s => s.active?.querySelector('.g-nav3__panel')?.contains(document.activeElement);
  function writeItem(item, open) {
    item.dataset.open = String(open);
    item.querySelector('.g-nav3__toggle')?.setAttribute('aria-expanded', String(open));
  }
  function close(nav, restore = false) {
    const s = states.get(nav);
    if (!s) return;
    clearOpen(s); clearClose(s);
    const trigger = s.active?.querySelector('.g-nav3__toggle');
    nav.querySelectorAll('.g-nav3__item').forEach(item => writeItem(item, false));
    s.active = null; s.source = null;
    if (restore) trigger?.focus({preventScroll:true});
  }
  function open(nav, item, source) {
    const s = states.get(nav);
    clearOpen(s); clearClose(s);
    if (source === 'hover' && panelHasFocus(s)) return;
    if (s.active !== item) {
      if (s.active) writeItem(s.active, false);
      writeItem(item, true);
      s.active = item;
    }
    s.source = source;
  }
  function laterClose(nav) {
    const s = states.get(nav);
    clearOpen(s); clearClose(s);
    s.closeTimer = setTimeout(() => { if (!panelHasFocus(s)) close(nav); }, 180);
  }
  function mobileOpen(nav, value) {
    nav.dataset.menuOpen = String(value);
    const button = nav.querySelector('.g-nav3__mobile-toggle');
    button?.setAttribute('aria-expanded', String(value));
    const symbol = button?.querySelector('span');
    if (symbol) symbol.textContent = value ? '−' : '+';
    if (!value) close(nav);
  }
  function chooseTab(tab, focus = false) {
    const nav = tab.closest('.g-nav3');
    nav.querySelectorAll('[role="tab"]').forEach(t => {
      const selected = t === tab;
      t.setAttribute('aria-selected', String(selected));
      t.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel && nav.contains(panel)) panel.hidden = !selected;
    });
    if (focus) tab.focus();
  }
  function prepare(root = document) {
    const navs = [...root.querySelectorAll('.g-nav3')];
    if (root.matches?.('.g-nav3')) navs.unshift(root);
    navs.forEach(nav => {
      if (states.has(nav)) return;
      const s = {active:null, source:null, openTimer:null, closeTimer:null};
      states.set(nav, s);
      nav.dataset.enhanced = 'true';
      nav.dataset.navigationVersion = '6';
      mobileOpen(nav, false);
      const first = nav.querySelector('[role="tab"]');
      if (first) chooseTab(first);
      nav.querySelectorAll('.g-nav3__item').forEach(item => {
        const top = item.querySelector('.g-nav3__top');
        top?.addEventListener('pointerenter', e => {
          if (!desktop.matches || e.pointerType === 'touch') return;
          clearOpen(s); clearClose(s);
          if (s.active === item || panelHasFocus(s)) return;
          s.openTimer = setTimeout(() => open(nav, item, 'hover'), 120);
        });
        item.addEventListener('pointerenter', e => {
          if (desktop.matches && e.pointerType !== 'touch' && s.active === item) clearClose(s);
        });
        item.addEventListener('pointerleave', e => {
          if (!desktop.matches || e.pointerType === 'touch') return;
          laterClose(nav);
        });
      });
      nav.addEventListener('pointerleave', e => {
        if (desktop.matches && e.pointerType !== 'touch') laterClose(nav);
      });
      nav.addEventListener('pointercancel', e => {
        clearOpen(s); clearClose(s);
        if (e.pointerType !== 'touch') close(nav);
      });
      nav.addEventListener('focusout', () => {
        // Native focusout runs before the next control receives focus.
        // Wait for the full browser focus transaction, not a microtask.
        setTimeout(() => {
          const focused = document.activeElement;
          if (!nav.contains(focused)) mobileOpen(nav, false);
          else if (s.active && !s.active.contains(focused)) close(nav);
        }, 0);
      });
    });
  }
  prepare();
  document.addEventListener('shopify:section:load', e => prepare(e.target));
  document.addEventListener('click', e => {
    const target = e.target instanceof Element ? e.target : e.target.parentElement;
    const nav = target?.closest('.g-nav3');
    document.querySelectorAll('.g-nav3').forEach(other => {
      if (other !== nav) { close(other); mobileOpen(other, false); }
    });
    if (!nav || !states.has(nav)) return;
    const s = states.get(nav);
    const toggle = target.closest('.g-nav3__toggle');
    if (toggle) {
      const item = toggle.closest('.g-nav3__item');
      if (s.active === item) close(nav);
      else open(nav, item, 'click');
      return;
    }
    if (target.closest('.g-nav3__mobile-toggle')) { mobileOpen(nav, nav.dataset.menuOpen !== 'true'); return; }
    if (target.closest('.g-nav3__close')) { close(nav, true); return; }
    const tab = target.closest('[role="tab"]');
    if (tab) chooseTab(tab);
    if (target.closest('a')) { close(nav); mobileOpen(nav, false); }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.g-nav3').forEach(nav => {
        const active = states.get(nav)?.active;
        if (active) { e.preventDefault(); close(nav, nav.contains(document.activeElement)); }
        else if (nav.dataset.menuOpen === 'true') {
          e.preventDefault(); mobileOpen(nav, false);
          nav.querySelector('.g-nav3__mobile-toggle')?.focus({preventScroll:true});
        } else close(nav); // Cancel a hover that has not opened yet.
      });
    }
    const tab = e.target.closest?.('.g-nav3 [role="tab"]');
    if (tab && ['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) {
      e.preventDefault();
      const tabs = [...tab.closest('.g-nav3').querySelectorAll('[role="tab"]')];
      let i = tabs.indexOf(tab);
      i = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      chooseTab(tabs[i], true);
    }
  });
  const reset = () => document.querySelectorAll('.g-nav3').forEach(nav => { close(nav); mobileOpen(nav, false); });
  desktop.addEventListener('change', reset);
  window.addEventListener('blur', reset);
  window.addEventListener('pagehide', reset);
  document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); });
})();

/* Welcome offer ends 14 Oct 2026 at 08:05 CEST. Keep the footer signup available. */
(() => {
  const expiresAt = Date.parse('2026-10-14T06:05:00Z');
  const closeExpiredWelcomeOffer = () => {
    const remaining = expiresAt - Date.now();
    if (remaining > 0) {
      window.setTimeout(closeExpiredWelcomeOffer, Math.min(remaining, 2147483647));
      return;
    }
    if (document.getElementById('glamosia-welcome-offer-expired')) return;
    const style = document.createElement('style');
    style.id = 'glamosia-welcome-offer-expired';
    style.textContent = '#pushowl-popup-campaign-15856{display:none!important}';
    document.head.appendChild(style);
  };
  closeExpiredWelcomeOffer();
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && Date.now() >= expiresAt) closeExpiredWelcomeOffer();
  });
})();
